import { render, staticRenderFns } from "./product-toggle-favorites.component.vue?vue&type=template&id=329e1a98&"
import script from "./product-toggle-favorites.component.ts?vue&type=script&lang=ts&"
export * from "./product-toggle-favorites.component.ts?vue&type=script&lang=ts&"
import style0 from "./product-toggle-favorites.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
